import React from "react";
import PropTypes from "prop-types";

import { NO_OP_FUNCTION } from "services/helpers";
import { colorConverter } from "./helpers";
import "./style.scss";

class ColorInput extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    submitChange: PropTypes.func,
    handleChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    submitChange: NO_OP_FUNCTION
  };

  colorSubmit = (e, handleChange, submitChange) => {
    handleChange(e.target.value.replace(/\s/g, ""));
    submitChange(e.target.value.replace(/\s/g, ""));
  };

  /**
   * renders the component
   * @returns {React.Component} Color Input field
   */
  render() {
    const { value, handleChange, submitChange } = this.props;

    return (
      <div className="ColorInput">
        <div className="ColorInput__selector-container">
          <input
            className="ColorInput__selector-container__selector"
            type="color"
            value={colorConverter(value)}
            onChange={e => this.colorSubmit(e, handleChange, submitChange)}
          />
          <div
            className="ColorInput__selector-container__preview"
            style={{ backgroundColor: value }}
          />
        </div>
        <input
          className="ColorInput__input g-input"
          type="text"
          spellCheck={false}
          placeholder="Tint Color"
          value={value}
          onChange={e => handleChange(e.target.value.replace(/\s/g, ""))}
          onBlur={e => submitChange(colorConverter(e.target.value.replace(/\s/g, "")))}
        />
      </div>
    );
  }
}

export default ColorInput;
